import React from "react";
import UsersComponent from "../../../components/Settings/Users";

export default function UsersPage() {
    return <UsersComponent />;
}
